import React from "react";
import { renderContentWithLineBreaks } from "../utils/renderContentWithLineBreaks";

interface ServiceCardProps {
    title: string;
    img: string;
    bgColor: string;
    description: string | undefined;
    button?: React.ReactNode;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
    title,
    img,
    bgColor,
    description,
    button,
}) => (
    <div className="flex flex-col items-center min-h-[350px] md:min-h-[450px] max-w-[550px] w-full rounded-xl shadow-lg overflow-hidden bg-white">
        <div className="w-full bg-white/90 shadow-none overflow-hidden rounded-t-xl">
            {img && (
                <img
                    src={img}
                    alt={title}
                    className="w-full h-[180px] md:h-[250px] lg:h-[350px] object-cover rounded-t-xl"
                />
            )}
        </div>
        <div className="w-full" style={{ height: "20px", background: "transparent" }} />
        <div className={`w-full pb-16 px-6 ${bgColor} text-white shadow-none flex flex-col items-center flex-1 text-center font-raleway rounded-b-xl`}>
            <h3 className="text-3xl font-bold text-white mb-6 text-center mt-8 ">
                {title}
            </h3>
            <div className="mb-4">{renderContentWithLineBreaks(description)}</div>
            {button && <div className="mt-auto mb-4">{button}</div>}
        </div>
    </div>
);

export default ServiceCard;